import React from 'react';
import './LoadingFallback.css';

export const LoadingFallback: React.FC = () => {
  return (
    <div className="loading-fallback">
      <div className="loading-fallback-spinner"></div>
      <p className="loading-fallback-text">Loading...</p>
    </div>
  );
};

export default LoadingFallback;
